import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

class Popup {
  /**
   *
   * @param {HTMLElement} container
   */
  constructor(container) {
    this.container = container
    this.scrollContainer = this.container.querySelector('[data-scroll-area]')
    this.name = this.container.dataset.popupName
  }
  close() {
    this.container.classList.remove('is-active')
    enableBodyScroll(this.scrollContainer)
  }
  open() {
    this.container.classList.add('is-active')
    disableBodyScroll(this.scrollContainer)
  }
  run(actionName) {
    if (actionName === 'close') {
      return this.close()
    }
    if (actionName === 'open') {
      return this.open()
    }
  }
}

const popups = {}
document.querySelectorAll('.popup').forEach((container) => {
  const popup = new Popup(container)
  popups[popup.name] = popup
})

document.addEventListener('click', (event) => {
  const { target } = event
  if (target.closest('[data-popup-action]')) {
    event.preventDefault()
    const element = target.closest('[data-popup-action]')
    const action = element.dataset.popupAction
    const scope = element.dataset.popupActionScope
    if (scope in popups) {
      popups[scope].run(action)
    } else {
      throw new Error(`Popup ${scope} not found`)
    }
  }

  if (target.classList.contains('popup')) {
    const scope = target.dataset.popupName
    if (scope in popups) {
      popups[scope].close()
    } else {
      throw new Error(`Popup ${scope} not found`)
    }
  }
})

window.asbPopups = {
  items: popups,
  open(scope) {
    if (scope in popups) {
      popups[scope].open()
    } else {
      throw new Error(`Popup ${scope} not found`)
    }
  },
  close(scope) {
    if (scope in popups) {
      popups[scope].close()
    } else {
      throw new Error(`Popup ${scope} not found`)
    }
  }
}
